import { createMultiParser, createParser } from 'nuqs';
export const parseAsKeyValue = (options) => {
    const { keyLabel = 'key', valueLabel = 'value', separator = ',', } = options;
    return createParser({
        parse: (value) => {
            const [key, val] = value.split(separator);
            if (!key || !val) {
                return null;
            }
            return {
                [keyLabel]: key,
                [valueLabel]: val,
            };
        },
        serialize: (value) => {
            return `${value[keyLabel]}${separator}${value[valueLabel]}`;
        },
    });
};
export const parseAsMultiple = (options) => (itemParser) => {
    const parser = parseAsKeyValue(options);
    const { keyLabel, valueLabel, } = options;
    return createMultiParser({
        parse: (values) => {
            const keyValue = values.map(parser.parse).filter((v) => v !== null);
            return keyValue.flatMap((KeyValueItem) => {
                const parsedKey = itemParser.parse(KeyValueItem[keyLabel]);
                const parsedValue = itemParser.parse(KeyValueItem[valueLabel]);
                return parsedValue === null
                    ? []
                    : [
                        {
                            [keyLabel]: parsedKey,
                            [valueLabel]: parsedValue,
                        },
                    ];
            });
        },
        serialize: (values) => {
            return values.map((value) => {
                if (!itemParser.serialize) {
                    return '';
                }
                if (value[keyLabel] === null) {
                    return '';
                }
                return parser.serialize(value);
            });
        },
    });
};
